<script>
export default {
  name: "FAQContent",
  props: {
    questions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="nested">
      <div
        @click.stop="toggleShow(item)"
        class="togw"
        :class="{
          active: item.show && item.reply.length,
          last: !item.reply.length,
        }"
      >
        <h4>{{ item.title }}</h4>
        <div class="arrow" v-if="item.reply.length">
          <img src="/arrow2.png" alt="" v-if="!item.show" />
          <img src="/arrow2w.png" alt="" v-else />
        </div>
      </div>
      <div v-show="item.show" style="width: 100%; margin-top: 5px">
        <NestedItem :items="item.reply" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NestedItem",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  methods: {
    toggleShow(item) {
      if (!item.reply.length) return;
      if (item.show === undefined) {
        this.$set(item, "show", false);
      }
      item.show = !item.show;
    },
  },
};
</script>

<style lang="scss" scoped>
.nested {
  padding-left: 15px;
  margin-top: 5px;
}
.togw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1.5px dotted #d4d4d4;
  padding: 0px 10px;
  border-radius: 10px;
  &.active {
    background: #28919a;
    color: white;
  }
  .arrow {
    margin-right: 15px;
    position: absolute;
    right: 25px;
  }
}

h4 {
  margin: 0;
  padding: 10px 0;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.4;
}
.last {
  background-color: white;
  color: #7c7c7c;
}
</style>
